import { BodySecondary, LabelStrong } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import React from 'react';
import styled from 'styled-components';
import Tooltip, { Header, Message } from '@liveauctioneers/caterwaul-components/lib/Tooltip/Tooltip';

type Props = {
    darkGrey?: boolean;
    info: React.ReactNode;
    popoverContent: React.ReactNode;
    price?: React.ReactNode;
    title: React.ReactNode;
};

const ShippingMethodLabel = ({ darkGrey, info, popoverContent, price, title }: Props) => {
    return (
        <StyledLabel>
            <RadioTitleRow>
                <LabelStrong color={darkGrey ? 'secondary' : 'primary'}>{title}</LabelStrong>
                <Tooltip
                    trigger={
                        <StyledInfoIconExtraSmall
                            color="primary"
                            size="xs"
                            style="fill"
                        />
                    }
                >
                    <Header>
                        <FormattedMessage id="checkout.shippingMethod.popovers.title" />
                    </Header>
                    <Message last>{popoverContent}</Message>
                </Tooltip>
            </RadioTitleRow>
            <StyledInfo>
                <BodySecondary color="secondary">{info}</BodySecondary>
            </StyledInfo>
            <StyledPrice>{price}</StyledPrice>
        </StyledLabel>
    );
};

export default ShippingMethodLabel;
const StyledLabel = styled.div`
    display: grid;
    grid-template:
        'title price'
        'info price'
        /3fr 1fr;
    grid-row-gap: 4px;
    grid-column-gap: 16px;
`;

const RadioTitleRow = styled.div`
    grid-area: title;
    display: flex;
    align-items: center;
`;

const StyledInfo = styled.div`
    grid-area: info;
`;

const StyledPrice = styled(LabelStrong)`
    grid-area: price;
    text-align: end;
`;

const StyledInfoIconExtraSmall = styled(Info)`
    margin-left: 3px;
    margin-bottom: -3px;
`;
